<template>
  <div>
    <!-- btn controll solution -->
    
    <div v-if="viewMore === ''">
      <h6>Is your Problem resolved ?</h6>
      <a-space>
        <a-button @click="() => (viewMore = 'evaluation')" type="primary">
          Yes
        </a-button>
        <a-button @click="() => (viewMore = 'MoreQuestion')" type="danger">
          No
        </a-button>
      </a-space>
    </div>
    <!-- form - 1 -->
    <div v-if="viewMore === 'evaluation'">
      <h6>Satisfaction Assessment</h6>
      <a-rate style="font-size: 24px" v-model="formResolved.ticketpoint" />
      <a-form-item class="mt-10 mb-10">
        <a-textarea
          v-model="formResolved.ticketcomment"
          placeholder="Add more suggestion (if any) ..."
          :rows="4"
        />
      </a-form-item>
      
      <a-space>
        <div v-if="!loading.formA">
          <a-button @click="submitEvaluation" class="mr-10" type="primary">
            Submit
          </a-button>
          <a-button @click="clearCondition" type="danger"> Cancel </a-button>
        </div>
        <p v-else class="mt-10 mb-10"><a-spin class="mr-5" />Loading...</p>
      </a-space>
    </div>
    <!-- form -2 -->
    <div v-if="viewMore === 'MoreQuestion'">
      <h6>Question / issue</h6>
      <a-form-item class="mb-5">
        <a-textarea
          v-model="formWaitComment.message"
          placeholder="Add more question ..."
          :rows="4"
        />
      </a-form-item>
      <a-form :layout="'horizontal'">
        <a-form-item
          class="mb-10"
          label="Attachments (if any)"
          :label-col="{ span: 7 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-upload
            :file-list="fileList"
            :remove="handleRemove"
            :before-upload="beforeUpload"
            :multiple="false"
            v-model="formWaitComment.upload_file"
            extra="*** Screen-shot of issue (showing the Problemm, disconnects or failed connections, etc.)"
          >
            <a-button> <a-icon type="upload" /> Upload </a-button>
          </a-upload>
        </a-form-item>
      </a-form>
      <a-space>
        <div v-if="!loading.formB">
          <a-button
            @click="submitCommentWaitTicket"
            class="mr-10"
            type="primary"
          >
            Submit
          </a-button>
          <a-button @click="clearCondition" type="danger"> Cancel </a-button>
        </div>
        <p v-else class="mt-10 mb-10"><a-spin class="mr-5" />Loading...</p>
      </a-space>
    </div>
  </div>
</template>

<script>
const formEvaluation = {
  ticketcomment: "",
  ticketpoint: 0,
};
const formMore = {
  message: "",
  upload_file: null,
};
export default {
  props: {
    dataAccept: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formResolved: Object.assign({}, formEvaluation),
      formWaitComment: Object.assign({}, formMore),
      viewMore: "",
      // loadingBtn
      loading: {
        formA: false,
        formB: false,
      },
      // file upload
      fileList: [],
      uploading: false,
      errorFile: "",
    };
  },
  methods: {
    clearCondition() {
      this.formResolved = Object.assign({}, formEvaluation);
      this.formWaitComment = Object.assign({}, formMore);
      this.loading.formA = false;
      this.loading.formB = false;
      // file clear
      this.fileList = [];
      this.uploading = false;
      this.errorFile = "";
      // file clear
      this.viewMore = "";
    },
    // more comment
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      this.formWaitComment.upload_file = file;
      this.fileList = [...this.fileList, file];
      return false;
    },
    async submitCommentWaitTicket() {
      this.loading.formB = true;
      try {
        const sendMsgComment = new FormData();
        sendMsgComment.append("msg_type", 'ask');
        sendMsgComment.append("message",  ![null,'null',''].includes(this.formWaitComment.message) ? this.formWaitComment.message : 'More document example ...');
        if (this.formWaitComment.upload_file !== null) {
          sendMsgComment.append(
            "upload_file",
            this.formWaitComment.upload_file
          );
        } else {
          sendMsgComment.append("upload_file", null);
        }
        const resCreateMsg = await this.$http.post(
          `/ticket/msg/push/${this.dataAccept.id}/`,
          sendMsgComment,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (resCreateMsg.status === 201) {
          this.$emit("addNewComment", resCreateMsg.data);
          this.handleRemove(this.formWaitComment.upload_file) 
          this.clearCondition();
          this.loading.formB = false;
        }
      } catch (error) {
        this.loading.formB = false;
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /ticket/msg/push/${this.dataAccept.id}/`,
        });
      }
    },
    // close-ticket
    async addEvaluation() {
      const sendVote = new FormData();
      sendVote.append("ticketcomment", this.formResolved.ticketcomment);
      sendVote.append("ticketpoint", this.formResolved.ticketpoint);
      try {
        const resVote = await this.$http.patch(
          `/ticket/vote/${this.dataAccept.id}/`,
          sendVote,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (resVote.status === 200) {
          this.$emit("changeStatusTicket", resVote.data);
          this.clearCondition();
        } else {
          const error = new Error('Request Failed');
          error.resVote = resVote;
          error.response = resVote;
          throw error;
        }
      } catch (error) {
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /ticket/vote/${this.dataAccept.id}/`,
        });
      }
    },
    async submitEvaluation() {
      this.loading.formA = true;
      try {
        const closeJob = await this.$http.patch(
          `/ticket/close/${this.dataAccept.id}/`,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (closeJob.status === 200) {
          await this.addEvaluation();
          this.loading.formA = false;
        } else {
          const error = new Error('Request Failed');
          error.closeJob = closeJob;
          error.response = closeJob;
          throw error;
        }
      } catch (errorMain) {
        this.loading.formA = false;
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${errorMain.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /ticket/close/${this.dataAccept.id}/`,
        });
      }
    },
  },
};
</script>